<template>
  <v-hover v-slot:default="{ hover }">
    <div>
      <v-row no-gutters>
        <v-col cols="1">
          <v-icon medium>mdi-bell</v-icon>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters>            
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon icon color="primary" v-on="on" @click="edit">mdi-pencil</v-icon>
              </template>
              <span>{{$t('Edit')}}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon icon color="red" v-on="on" @click="remove">mdi-delete</v-icon>
              </template>
              <span>{{$t('Delete')}}</span>
            </v-tooltip>
            <span class="ml-2" v-if="alert.notifyByEmail"><v-icon color="success">mdi-email</v-icon></span>
            <span class="ml-2" v-if="!alert.notifyByEmail"><v-icon color="error">mdi-email</v-icon></span>
            <span class="ml-2">{{alert.date}}</span>
          </v-row>
          <v-row no-gutters>
            <span>{{alert.description}}</span>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>
    </div>
  </v-hover>
</template>
<script>
import Utils from "@/ecm/common/Utils";
export default {
  props: {
    alert: {
      type: Object
    }
  },
  methods: {
    edit() {
      this.$emit("on-edit-alert", Utils.object.toJS(this.alert));
    },
    remove() {
      this.$emit("on-remove-alert", this.alert.id);
    }
  }
};
</script>